<script setup lang="ts">
import { pushSubscriptionsApi } from '@/api/push-subscriptions';
import { useStore } from '@/store/store';
import { onBeforeMount, onMounted, provide } from 'vue';

interface Props {
  autoRejectHours: number,
  clientServiceCost: number,
  partnerServiceCost: number,
  automaticReturnMinutes: number,
  activeReferralCampaign: boolean,
  user: User
}

const props = defineProps<Props>();

const store = useStore();

if (store.backUrl &&
  !document.referrer.endsWith(store.backUrl.fromHref) &&
  !document.referrer.endsWith(store.backUrl.toHref)) {
  store.resetBackUrl();
}

onBeforeMount(() => {
  provide('autoRejectHours', props.autoRejectHours);
  provide('clientServiceCost', props.clientServiceCost);
  provide('partnerServiceCost', props.partnerServiceCost);
  provide('automaticReturnMinutes', props.automaticReturnMinutes);
  provide('activeReferralCampaign', props.activeReferralCampaign);
  provide('user', props.user);
});

function handlePosition(position:GeolocationPosition) {
  store.setUserLocation(position.coords);
}

function handlePositionError() {
  store.resetUserLocation();
}

onMounted(() => {
  navigator.geolocation.getCurrentPosition(handlePosition, handlePositionError);
  store.resetHasNewMessages();
});

function isPushSupported() {
  return 'Notification' in window &&
    'serviceWorker' in navigator &&
    'PushManager' in window;
}

if (props.user && isPushSupported()) {
  Notification.requestPermission();

  navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
    serviceWorkerRegistration.pushManager
      .subscribe({
        userVisibleOnly: true,
        applicationServerKey: window.vapidPublicKey,
      })
      .then((subscription) => {
        pushSubscriptionsApi.create(props.user.id, subscription.toJSON());
      });
  });
}
</script>
<template>
  <slot />
</template>
